import { useParams } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import { setlatestDealSubmit } from 'cache/latest-deal-info'
import { IGetLatestDealVersionRequest } from 'queries/getLatestDealVersion'
import GET_LATEST_DEAL_SUBMIT, { IGetLatestSubmitResponse } from 'queries/getLatestSubmit'

export const useLatestSubmit = () => {
  const { dealNumber } = useParams<{ dealNumber: string }>()

  const [getLatestDealSubmit, { data, loading, error }] = useLazyQuery<
    IGetLatestSubmitResponse,
    IGetLatestDealVersionRequest
  >(GET_LATEST_DEAL_SUBMIT, { fetchPolicy: 'no-cache' })

  const handleGetLatestDealSubmit = async () => {
    try {
      await getLatestDealSubmit({
        variables: {
          dealNumber: parseInt(dealNumber),
        },
      })
    } catch (error) {
      return { error }
    }
  }

  if (data?.latestSubmitByDeal) {
    setlatestDealSubmit(data)
  }

  return {
    getLatestDealSubmit: handleGetLatestDealSubmit,
    data,
    loading,
    error,
  }
}
